import i18next from "i18next";
import { success, custom } from "./utilities";
import { ToastifyService, profileService } from "../../services";
import {
  profileConstants,
  translationConstants,
  globalSystemConstants,
} from "../../constants";

export const getProfileImageUrl = (systemUserId) => {
  return (dispatch) => {
    dispatch(
      custom(
        profileConstants.GET_PROFILE_IMAGE_URL,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    profileService
      .getProfileImageUrl(systemUserId)
      .then((response) => {
        dispatch(success(response, profileConstants.GET_PROFILE_IMAGE_URL));
      })
      .catch((error) => {
        // console.error(i18next.t(error));
      })
      .finally(() =>
        dispatch(
          custom(
            profileConstants.GET_PROFILE_IMAGE_URL,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        )
      );
  };
};

export const uploadProfilePic = (formData) => {
  return (dispatch) => {
    dispatch(
      custom(
        profileConstants.UPLOAD_PROFILE_PIC,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );

    profileService
      .UploadProfilePic(formData)
      .then((x) => {
        ToastifyService.showSuccess(
          i18next.t(translationConstants.PROFILE_IMAGE_UPDATED)
        );
      })
      .catch((error) => {
        ToastifyService.showError(
          i18next.t(translationConstants.PROFILE_IMAGE_NOT_UPLOAD)
        );
      })
      .finally(() => {
        dispatch(
          custom(
            profileConstants.UPLOAD_PROFILE_PIC,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const setProfilePicPreview = (data) => {
  return (dispatch) => {
    try {
      dispatch(success(data, profileConstants.GET_PROFILE_IMAGE_URL));
    } catch (error) {
      ToastifyService.showError(error);
    }
  };
};

export const getProfileData = (systemUserId) => {
  return (dispatch) => {
    dispatch(
      custom(
        profileConstants.GET_PROFILE_DATA,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );

    profileService
      .getProfileData(systemUserId)
      .then((response) =>
        dispatch(custom(response, profileConstants.GET_PROFILE_DATA))
      )
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            profileConstants.GET_PROFILE_DATA,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const updateProfileSate = (data) => {
  return (dispatch) => {
    try {
      dispatch(custom(data, profileConstants.GET_PROFILE_DATA));
    } catch (error) {
      ToastifyService.showError(error);
    }
  };
};

export const updateProfileData = (formData) => {
  return (dispatch) => {
    dispatch(
      custom(
        profileConstants.UPDATE_PROFILE_DATA,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    profileService
      .updateProfile(formData)
      .then((response) => {
        ToastifyService.showSuccess(i18next.t(response));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            profileConstants.UPDATE_PROFILE_DATA,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const profileActions = {
  getProfileImageUrl,
  uploadProfilePic,
  setProfilePicPreview,
  getProfileData,
  updateProfileSate,
  updateProfileData,
};
